function enableUpdateCartButton() {
  jQuery('.woocommerce-cart').find('button[name="update_cart"]').prop('disabled', false);
}

export {
  enableUpdateCartButton
};
